class SpotLight {
	static instance = null;

	static create(data) {
		if (!SpotLight.instance) {
			SpotLight.instance = new SpotLight(data);
		}
		return SpotLight.instance;
	}

	static destroy() {
		if (SpotLight.instance) {
			SpotLight.instance.beforeDestroy();
			SpotLight.instance = null;
		}
	}

	constructor(data) {
		this.activeEl = null;
		this.timeoutId = null;
		this.item = data.querySelectorAll('[data-hover]');
		this.init();
	}

	init() {
		if (!!this.item.length) {
			this.activeEl = this.item[0];
			this.activeEl.classList.add('active');
			this.item.forEach((el) => {
				el.addEventListener('mouseenter', () => {
					clearTimeout(this.timeoutId);

					if (el === this.activeEl) {
						return;
					}

					this.activeEl.classList.remove('active');
					this.activeEl = el;
					this.activeEl.classList.add('active');

					const id = this.activeEl.getAttribute('data-hover');
					const img = document.getElementById(id);

					this.timeoutId = setTimeout(() => {
						const src = this.activeEl.children[0].getAttribute('src');
						img.setAttribute('src', src);
						img.style.opacity = 0;
						img.onload = () => {
							img.style.opacity = 1;
						};
					}, 400);
				});
			});
		}
	}

	beforeDestroy() {
		this.item.forEach((el) => {
			el.removeEventListener('mouseenter');
		});
	}
}


export default SpotLight;